import axios2 from 'axios';
import { createSlice, Dispatch } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
// @types
import {
    IProfileState,
    IUserPostsPageState,
    IUserFollowersPageState,
    IUserFriendsPageState,
    IUserExploreResultState,
    IUserPostDetail,
    IUserPost,
    IUserFriend,
    IUserNewPost,
    IExplorePostsPageState
} from '../../@types/user';


const initialUserPostsPageState: IUserPostsPageState = {
    data: [],
    isLastPage: true,
    lastKey: undefined,
    lastTimestamp: "",
    newPosts: [],
    newPostsCount: 0,
    profileEmail: "",
    keywords: "",
    scrollTopPos: 0,
    scrollTopPosUpdateTime: 0,
    selectedId: "",
    selectedIdUpdateTime: 0
    // selectedElement: null
}
const initialExploreResultState: IExplorePostsPageState = {
    data: [],
    isLastPage: true,
    lastKey: undefined,
    lastTimestamp: "",
    newPosts: [],
    newPostsCount: 0,
    keywords: "",
    scrollTopPos: 0,
    scrollTopPosUpdateTime: 0,
    selectedId: "",
    selectedIdUpdateTime: 0
    // selectedElement: null
}



const initialExploreUserResultState: IUserExploreResultState = {
    data: [],
    isLastPage: true,
    lastKey: undefined,
    keywords: '',
    scrollTopPos: 0,
    selectedId: '',
    scrollTopPosUpdateTime: 0,
    selectedIdUpdateTime: 0,
}
const initialUserFollowersPageState: IUserFollowersPageState = {
    data: [],
    isLastPage: true,
    lastKey: undefined,
}
const initialUserFriendsPageState: IUserFriendsPageState = {
    data: [],
    isLastPage: true,
    lastKey: undefined,
}

const initialState: IProfileState = {
    isLoading: false,
    isProcessing: false,
    isLoadingMore: false,
    isFetching: false,
    isLoadingNew: false,
    // isEmpty: false,
    error: null,

    userPostPage: null,
    userProfile: null,
    exploredPostResult: initialExploreResultState,
    exploreUserResult: initialExploreUserResultState,
    userFavoritePostsPage: initialUserPostsPageState,
    userPostsPage: initialUserPostsPageState,
    userFollowersPage: initialUserFollowersPageState,
    userFriendsPage: initialUserFriendsPageState,
    // listingPage: {
    //     data: [],
    //     pageNumber: 1,
    //     pageSize: 10,
    //     isLastPage: true,
    //     nextKey: null,
    // },
    // news: null,
    // isLastPage: true,
};

const slice = createSlice({
    name: 'userProfile',
    initialState,
    reducers: {
        // resetState(state) {
        //     // // console.log(`reset(state);`);
        //     // console.log(`reset(state);`);
        //     // console.log(`initialState`)
        //     console.log(initialState)
        //     state = initialState;
        //     // console.log(`state`)
        //     console.log(state)
        // }, 
        resetState: () => initialState,
        startLoading(state) {
            state.error = null;
            state.isLoading = true;
        },
        startLoadingMore(state) {
            state.error = null;
            state.isLoadingMore = true;
        },
        startFetching(state) {
            state.error = null;
            state.isFetching = true;
        },
        startLoadingNew(state) {
            state.error = null;
            state.isLoadingNew = true;
        },
        resetUserProfilePost(state) {
            state.userPostsPage = initialUserPostsPageState;
        },
        resetUserFavoritePostsPage(state) {
            state.userFavoritePostsPage = initialUserPostsPageState;
        },
        resetUserFrd(state) {
            state.userFollowersPage = initialUserFollowersPageState;
        },
        resetUserFwr(state) {
            state.userFriendsPage = initialUserFriendsPageState;
        },
        resetExplore(state) {
            state.exploreUserResult = initialExploreUserResultState;
        },

        // setSelectedElementSuccess(state, action) {
        //     state.userPostsPage.selectedElement = action.payload;
        // },
        // resetSelectedElementSuccess(state) {
        //     state.userPostsPage.selectedElement = null;
        // },
        // stopLoading(state){
        //     state.isLoading = false;
        // },

        followSuccess(state) {
            state.isProcessing = false;
        },
        unFollowSuccess(state) {
            state.isProcessing = false;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        resetError(state) {
            state.error = null;
        },
        startProcessing(state) {
            state.isProcessing = true;
        },
        stopProcessing(state) {
            state.isProcessing = false;
        },




        loadUserFriendsSuccess(state, action) {
            state.userFriendsPage.data = action.payload.data;
            state.userFriendsPage.lastKey = action.payload.LastEvaluatedKey;
            state.userFriendsPage.isLastPage = action.payload.isLast;
            state.isLoading = false;
        },
        loadMoreUserFriendsSuccess(state, action) {
            state.userFriendsPage.data = state.userFriendsPage.data.concat(action.payload.data);
            state.userFriendsPage.lastKey = action.payload.LastEvaluatedKey;
            state.userFriendsPage.isLastPage = action.payload.isLast;
            state.isLoadingMore = false;
            // state.isLoading = false;
        },


        loadUserFollowersSuccess(state, action) {
            state.userFollowersPage.data = action.payload.data;
            state.userFollowersPage.lastKey = action.payload.LastEvaluatedKey;
            state.userFollowersPage.isLastPage = action.payload.isLast;
            state.isLoading = false;
        },
        loadMoreUserFollowersSuccess(state, action) {
            state.userFollowersPage.data = state.userFollowersPage.data.concat(action.payload.data);
            state.userFollowersPage.lastKey = action.payload.LastEvaluatedKey;
            state.userFollowersPage.isLastPage = action.payload.isLast;
            state.isLoadingMore = false;
            // state.isLoading = false;
        },





        setUserFavoritePostsScrollTop(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            state.userFavoritePostsPage.scrollTopPos = action.payload.scrollTop;
            state.userFavoritePostsPage.scrollTopPosUpdateTime = now;
        },
        setUserFavoritePostsSeletedId(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            state.userFavoritePostsPage.selectedId = action.payload.selectedId;
            state.userFavoritePostsPage.selectedIdUpdateTime = now;
        },

        setExploreUserScrollTop(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            state.exploreUserResult.scrollTopPos = action.payload.scrollTop;
            state.exploreUserResult.scrollTopPosUpdateTime = now;
        },
        setExploreUserSeletedId(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            state.exploreUserResult.selectedId = action.payload.selectedId;
            state.exploreUserResult.selectedIdUpdateTime = now;
        },


        exploreUserKeywordsSuccess(state, action) {
            state.exploreUserResult.keywords = action.payload.keywords;
        },

        exploreUserSuccess(state, action) {
            state.exploreUserResult.keywords = action.payload.keywords;
            state.exploreUserResult.data = action.payload.data;
            state.exploreUserResult.lastKey = action.payload.LastEvaluatedKey;
            state.exploreUserResult.isLastPage = action.payload.isLast;
            state.isLoading = false;
        },
        loadMoreExploreUserSuccess(state, action) {
            state.exploreUserResult.data = state.exploreUserResult.data.concat(action.payload.data);
            state.exploreUserResult.lastKey = action.payload.LastEvaluatedKey;
            state.exploreUserResult.isLastPage = action.payload.isLast;
            state.isLoadingMore = false;
            // state.isLoading = false;
        },




        loadUserPostsSuccess(state, action) {
            state.userPostsPage.data = action.payload.data;
            state.userPostsPage.profileEmail = action.payload.profileEmail;
            state.userPostsPage.newPosts = [];
            state.userPostsPage.newPostsCount = 0;
            state.userPostsPage.lastKey = action.payload.LastEvaluatedKey;
            state.userPostsPage.lastTimestamp = action.payload.nextTimestamp;
            state.userPostsPage.isLastPage = action.payload.isLast;
            state.isLoading = false;
        },
        loadMoreUserPostsSuccess(state, action) {
            state.userPostsPage.data = state.userPostsPage.data.concat(action.payload.data);
            state.userPostsPage.lastKey = action.payload.LastEvaluatedKey;
            // state.userPostsPage.lastTimestamp = action.payload.nextTimestamp;
            state.userPostsPage.isLastPage = action.payload.isLast;
            // state.isLoading = false;
            state.isLoadingMore = false;
        },
        fetchNewUserPostsSuccess(state, action) {
            // const newData = action.payload.data.concat(state.userPostsPage.data)
            // state.userPostsPage.data = newData;
            if (state.userPostsPage.newPosts?.length)
                state.userPostsPage.newPosts = state.userPostsPage.newPosts.concat(action.payload.data);
            else
                state.userPostsPage.newPosts = action.payload.data
            // console.log(action.payload.data)
            state.userPostsPage.newPostsCount = state.userPostsPage.newPosts?.length || 0;
            state.userPostsPage.lastTimestamp = action.payload.nextTimestamp;
            // state.postsPage.lastKey = action.payload.LastEvaluatedKey;
            // state.postsPage.isLastPage = action.payload.isLast;
            state.isFetching = false;
            // state.isLoading = false;
        },
        loadNewUserPostsSuccess(state) {
            let newData;
            if (state.userPostsPage.newPosts)
                newData = state.userPostsPage.newPosts.concat(state.userPostsPage.data)
            else
                newData = state.userPostsPage.data
            state.userPostsPage.data = newData;
            state.userPostsPage.newPosts = [];
            state.userPostsPage.newPostsCount = 0;
            state.isLoadingNew = false;
        },

        // scrollTopPosUpdateTime
        // selectedIdUpdateTime


        setUserPostsScrollTop(state, action) {
            // // console.log("scrollTopPos, ", action.payload.scrollTop)
            const now = Math.floor(new Date().getTime() / 1000);
            state.userPostsPage.scrollTopPos = action.payload.scrollTop;
            state.userPostsPage.scrollTopPosUpdateTime = now;
        },
        setUserPostsSeletedId(state, action) {
            // // console.log("selectedId, ", action.payload.selectedId)
            const now = Math.floor(new Date().getTime() / 1000);
            state.userPostsPage.selectedId = action.payload.selectedId;
            state.userPostsPage.selectedIdUpdateTime = now;
        },

        setExplorePostsScrollTop(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            state.exploredPostResult.scrollTopPos = action.payload.scrollTop;
            state.exploredPostResult.scrollTopPosUpdateTime = now;
        },
        setExplorePostsSeletedId(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            state.exploredPostResult.selectedId = action.payload.selectedId;
            state.exploredPostResult.selectedIdUpdateTime = now;
        },












        loadExploredPostsSuccess(state, action) {
            state.exploredPostResult.keywords = action.payload.keywords;
            state.exploredPostResult.data = action.payload.data;
            state.exploredPostResult.newPosts = [];
            state.exploredPostResult.newPostsCount = 0;
            state.exploredPostResult.lastKey = action.payload.LastEvaluatedKey;
            state.exploredPostResult.lastTimestamp = action.payload.nextTimestamp;
            state.exploredPostResult.isLastPage = action.payload.isLast;
            state.isLoading = false;
        },
        loadMoreExploredPostsSuccess(state, action) {
            state.exploredPostResult.data = state.exploredPostResult.data.concat(action.payload.data);
            state.exploredPostResult.lastKey = action.payload.LastEvaluatedKey;
            // state.exploredPostResult.lastTimestamp = action.payload.nextTimestamp;
            state.exploredPostResult.isLastPage = action.payload.isLast;
            // state.isLoading = false;
            state.isLoadingMore = false;
        },
        fetchNewExploredPostsSuccess(state, action) {
            // const newData = action.payload.data.concat(state.userPostsPage.data)
            // state.userPostsPage.data = newData;
            if (state.exploredPostResult.newPosts?.length)
                state.exploredPostResult.newPosts = state.exploredPostResult.newPosts.concat(action.payload.data);
            else
                state.exploredPostResult.newPosts = action.payload.data
            // console.log(action.payload.data)
            state.exploredPostResult.newPostsCount = state.exploredPostResult.newPosts?.length || 0;
            state.exploredPostResult.lastTimestamp = action.payload.nextTimestamp;
            // state.postsPage.lastKey = action.payload.LastEvaluatedKey;
            // state.postsPage.isLastPage = action.payload.isLast;
            state.isFetching = false;
            // state.isLoading = false;
        },
        loadNewExploredPostsSuccess(state) {
            let newData;
            if (state.exploredPostResult.newPosts)
                newData = state.exploredPostResult.newPosts.concat(state.exploredPostResult.data)
            else
                newData = state.exploredPostResult.data
            state.exploredPostResult.data = newData;
            state.exploredPostResult.newPosts = [];
            state.exploredPostResult.newPostsCount = 0;
            state.isLoadingNew = false;
        },











        loadUserFavoritePostsPageSuccess(state, action) {
            state.userFavoritePostsPage.data = action.payload.data;
            state.userFavoritePostsPage.profileEmail = action.payload.profileEmail;
            state.userFavoritePostsPage.newPosts = [];
            state.userFavoritePostsPage.newPostsCount = 0;
            state.userFavoritePostsPage.lastKey = action.payload.LastEvaluatedKey;
            state.userFavoritePostsPage.lastTimestamp = action.payload.nextTimestamp;
            state.userFavoritePostsPage.isLastPage = action.payload.isLast;
            state.isLoading = false;
        },
        loadMoreUserFavoritePostsPageSuccess(state, action) {
            state.userFavoritePostsPage.data = state.userFavoritePostsPage.data.concat(action.payload.data);
            state.userFavoritePostsPage.lastKey = action.payload.LastEvaluatedKey;
            // state.userFavoritePostsPage.lastTimestamp = action.payload.nextTimestamp;
            state.userFavoritePostsPage.isLastPage = action.payload.isLast;
            // state.isLoading = false;
            state.isLoadingMore = false;
        },











        // getNewsSuccess(state, action) {
        //     state.isLoading = false;
        //     state.news = action.payload;
        // },

        likePostSuccess(state, action) {
            if (state.userPostPage)
                state.userPostPage.isLike = true;

            const postId = action.payload.postId;
            const dataList = state.userPostsPage.data;
            const favoritedataList = state.userFavoritePostsPage.data;
            const exploredPostResultList = state.exploredPostResult.data;
            if (dataList && dataList.length > 0) {
                const dataIndex = dataList.findIndex(item => item.postId === postId)
                if (state.userPostsPage.data[dataIndex]) {
                    state.userPostsPage.data[dataIndex].isLike = true;
                    state.userPostsPage.data[dataIndex].numOfLike += 1;
                }
            }
            if (favoritedataList && favoritedataList.length > 0) {
                const dataIndex = favoritedataList.findIndex(item => item.postId === postId)
                if (state.userFavoritePostsPage.data[dataIndex]) {
                    state.userFavoritePostsPage.data[dataIndex].isLike = true;
                    state.userFavoritePostsPage.data[dataIndex].numOfLike += 1;
                }
            }
            if (exploredPostResultList && exploredPostResultList.length > 0) {
                const dataIndex = exploredPostResultList.findIndex(item => item.postId === postId)
                if (state.exploredPostResult.data[dataIndex]) {
                    state.exploredPostResult.data[dataIndex].isLike = true;
                    state.exploredPostResult.data[dataIndex].numOfLike += 1;
                }
            }

            state.isProcessing = false;
        },
        unlikePostSuccess(state, action) {
            if (state.userPostPage)
                state.userPostPage.isLike = false;


            const postId = action.payload.postId;
            const dataList = state.userPostsPage.data;
            const favoritedataList = state.userFavoritePostsPage.data;
            const exploredPostResultList = state.exploredPostResult.data;

            if (dataList && dataList.length > 0) {
                const dataIndex = dataList.findIndex(item => item.postId === postId)
                if (state.userPostsPage.data[dataIndex]) {
                    state.userPostsPage.data[dataIndex].isLike = false;
                }
                state.userPostsPage.data[dataIndex].numOfLike -= 1;
            }
            if (favoritedataList && favoritedataList.length > 0) {
                const dataIndex = favoritedataList.findIndex(item => item.postId === postId)
                if (state.userFavoritePostsPage.data[dataIndex]) {
                    state.userFavoritePostsPage.data[dataIndex].isLike = false;
                    state.userFavoritePostsPage.data[dataIndex].numOfLike -= 1
                }
            }
            if (exploredPostResultList && exploredPostResultList.length > 0) {
                const dataIndex = exploredPostResultList.findIndex(item => item.postId === postId)
                if (state.exploredPostResult.data[dataIndex]) {
                    state.exploredPostResult.data[dataIndex].isLike = false;
                    state.exploredPostResult.data[dataIndex].numOfLike -= 1
                }
            }


            state.isProcessing = false;






        },


        likePostsSuccess(state, action) {
            const postId = action.payload.postId;
            const dataList = state.userPostsPage.data;
            const favoritedataList = state.userFavoritePostsPage.data;
            const exploredPostResultList = state.exploredPostResult.data;
            if (dataList && dataList.length > 0) {
                const dataIndex = dataList.findIndex(item => item.postId === postId)
                if (state.userPostsPage.data[dataIndex]) {
                    state.userPostsPage.data[dataIndex].isLike = true;
                    state.userPostsPage.data[dataIndex].numOfLike += 1;
                }
            }
            if (favoritedataList && favoritedataList.length > 0) {
                const dataIndex = favoritedataList.findIndex(item => item.postId === postId)
                if (state.userFavoritePostsPage.data[dataIndex]) {
                    state.userFavoritePostsPage.data[dataIndex].isLike = true;
                    state.userFavoritePostsPage.data[dataIndex].numOfLike += 1;
                }
            }
            if (exploredPostResultList && exploredPostResultList.length > 0) {
                const dataIndex = exploredPostResultList.findIndex(item => item.postId === postId)
                if (state.exploredPostResult.data[dataIndex]) {
                    state.exploredPostResult.data[dataIndex].isLike = true;
                    state.exploredPostResult.data[dataIndex].numOfLike += 1;
                }
            }


            state.isProcessing = false;
        },
        unlikePostsSuccess(state, action) {
            const postId = action.payload.postId;
            const dataList = state.userPostsPage.data;
            const favoritedataList = state.userFavoritePostsPage.data;
            const exploredPostResultList = state.exploredPostResult.data;

            if (dataList && dataList.length > 0) {
                const dataIndex = dataList.findIndex(item => item.postId === postId)
                if (state.userPostsPage.data[dataIndex]) {
                    state.userPostsPage.data[dataIndex].isLike = false;
                }
                state.userPostsPage.data[dataIndex].numOfLike -= 1;
            }
            if (favoritedataList && favoritedataList.length > 0) {
                const dataIndex = favoritedataList.findIndex(item => item.postId === postId)
                if (state.userFavoritePostsPage.data[dataIndex]) {
                    state.userFavoritePostsPage.data[dataIndex].isLike = false;
                    state.userFavoritePostsPage.data[dataIndex].numOfLike -= 1
                }
            }
            if (exploredPostResultList && exploredPostResultList.length > 0) {
                const dataIndex = exploredPostResultList.findIndex(item => item.postId === postId)
                if (state.exploredPostResult.data[dataIndex]) {
                    state.exploredPostResult.data[dataIndex].isLike = false;
                    state.exploredPostResult.data[dataIndex].numOfLike -= 1
                }
            }





            // const dataList = state.userPostsPage.data;
            // const dataIndex = dataList.findIndex(item => item.postId === postId)
            // if (state.userPostsPage.data[dataIndex])
            //     state.userPostsPage.data[dataIndex].isLike = false;


            state.isProcessing = false;
        },





        deleteUserPostSuccess(state, action) {
            // if (state.post)
            //     state.post.isLike = false;
            const postId = action.payload.postId;
            // // console.log(`postId : ${postId}`);

            if (state.userPostsPage) {
                const dataList = state.userPostsPage.data;
                const dataIndex = dataList.findIndex(item => item.postId === postId)
                if (dataIndex !== undefined && dataIndex > -1) {
                    dataList.splice(dataIndex, 1);
                    state.userPostsPage.data = dataList;
                }
            }
            if (state.exploredPostResult) {
                const dataList = state.exploredPostResult.data;
                const dataIndex = dataList.findIndex(item => item.postId === postId)
                if (dataIndex !== undefined && dataIndex > -1) {
                    dataList.splice(dataIndex, 1);
                    state.exploredPostResult.data = dataList;
                }
            }
            if (state.userFavoritePostsPage) {
                const dataList = state.userFavoritePostsPage.data;
                const dataIndex = dataList.findIndex(item => item.postId === postId)
                if (dataIndex !== undefined && dataIndex > -1) {
                    dataList.splice(dataIndex, 1);
                    state.userFavoritePostsPage.data = dataList;
                }
            }
            state.isProcessing = false;



        },
        replyPostSuccess(state, action) {
            // if (state.post)
            //     state.post.isLike = true;
            const replyItem = action.payload.reply;
            if (state.userPostPage) {

                if (!state.userPostPage.comments)
                    state.userPostPage.comments = [];

                if (replyItem.replyTo) {
                    const commentsIndex = state.userPostPage.comments.findIndex(item => item.replyId === replyItem.replyTo)
                    const replyTo = state.userPostPage.comments[commentsIndex];
                    // if (replyTo.replyComment && replyTo.replyComment.length > 0) {
                    //     replyTo.replyComment.push(replyItem)
                    // } else {
                    //     // replyTo.hasReply = true;
                    //     replyTo.replyComment.push(replyItem)
                    // }
                    if (replyTo) {
                        if (!replyTo.replyComment)
                            replyTo.replyComment = [];
                        replyTo.replyComment.push(replyItem)
                        state.userPostPage.comments[commentsIndex] = replyTo;
                    }
                } else {
                    state.userPostPage.comments.push(replyItem);
                }

            }
            state.isProcessing = false;
        },
        deleteReplyPostSuccess(state, action) {
            const replyId = action.payload.replyId;
            const replyTo = action.payload.replyTo;
            // // console.log(`replyId : ${replyId}`);
            // // console.log(`replyTo : ${replyTo}`);
            if (state.userPostPage) {
                if (replyTo) {
                    const replyToIndex = state.userPostPage.comments.findIndex(item => item.replyId === replyTo)
                    if (replyToIndex !== undefined && replyToIndex > -1) {
                        const replyToSubComment = state.userPostPage.comments[replyToIndex].replyComment;
                        const replyItemIndex = replyToSubComment.findIndex(item => item.replyId === replyId)
                        // state.userPostPage.comments[replyToIndex].replyComment[replyItemIndex];
                        if (replyItemIndex !== undefined && replyItemIndex > -1) {
                            replyToSubComment.splice(replyItemIndex, 1);
                            state.userPostPage.comments[replyToIndex].replyComment = replyToSubComment;
                        }
                    }
                } else {
                    const replyCommentList = state.userPostPage.comments;
                    const replyItemIndex = replyCommentList.findIndex(item => item.replyId === replyId)
                    if (replyItemIndex !== undefined && replyItemIndex > -1) {
                        replyCommentList.splice(replyItemIndex, 1);
                        state.userPostPage.comments = replyCommentList;
                    }
                }
            }

            state.isProcessing = false;
        },

        createdPostSuccess(state, action) {
            const profilePostItem = action.payload.profilePostItem;

            if (!state.userPostsPage.data)
                state.userPostsPage.data = [];

            if (state.userPostsPage.data && profilePostItem) {
                state.userPostsPage.data.unshift(profilePostItem);
            }
            state.isProcessing = false;
        },





        resetPost(state) {
            state.userPostPage = null;
        },

        getPostSuccess(state, action) {
            state.userPostPage = action.payload.postInfo;
            state.isLoading = false;
        },
        resetUserProfile(state) {
            state.userProfile = null;
        },
        getUserProfileSuccess(state, action) {
            state.userProfile = action.payload.user;
            state.isLoading = false;
        },



    }
});



// Reducer
export default slice.reducer;

export const {
    // resetState,
    startLoading,
    hasError,
    resetError,
    // startProcessing,
    // stopProcessing,

} = slice.actions;



export function resetState() {
    // console.log("resetState")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.resetState());
    }

}


export function loadUserFriends(profileEmail: string) {
    // console.log("loadUserFriends")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.resetUserFrd());
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/friends/${profileEmail}`);
            dispatch(slice.actions.loadUserFriendsSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadMoreUserFriends(profileEmail: string, nextKey: any) {
    // console.log("loadMoreUserFriends")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {
            const response = await axios.get(`/friends/${profileEmail}`, {
                params: {
                    lastKey: nextKey,
                }
            });
            dispatch(slice.actions.loadMoreUserFriendsSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function loadUserFollowers(profileEmail: string) {
    // console.log("loadUserFollowers")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.resetUserFwr());
        dispatch(slice.actions.startLoading());


        try {
            const response = await axios.get(`/followers/${profileEmail}`);
            dispatch(slice.actions.loadUserFollowersSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadMoreUserFollowers(profileEmail: string, nextKey: any) {
    // console.log("loadMoreUserFollowers")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {
            const response = await axios.get(`/followers/${profileEmail}`, {
                params: {
                    lastKey: nextKey,
                }
            });
            dispatch(slice.actions.loadMoreUserFollowersSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}



export function exploreUser(keywords: string) {
    // console.log("exploreUser")
    return async (dispatch: Dispatch) => {

        // // console.log(`explore user with ${keywords}`);
        dispatch(slice.actions.resetExplore());
        dispatch(slice.actions.startLoading());


        try {
            const response = await axios.get(`/explore-user`, {
                params: {
                    keywords,
                }
            });
            dispatch(slice.actions.exploreUserSuccess({ keywords, ...response.data }));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}
export function loadMoreExploreUser(keywords: string, nextKey: string) {
    // console.log("loadMoreExploreUser")
    return async (dispatch: Dispatch) => {
        // dispatch(slice.actions.resetUserFwr());
        dispatch(slice.actions.startLoadingMore());
        // dispatch(slice.actions.resetUserFwr());


        try {
            const response = await axios.get(`/explore-user`, {
                params: {
                    keywords,
                    lastKey: nextKey,
                }
            });
            dispatch(slice.actions.loadMoreExploreUserSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function follow(friendEmail: string,) {
    // console.log("follow")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.put(`/follow/${friendEmail}`);
            dispatch(slice.actions.followSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            // dispatch(slice.actions.UpdateFail());
        }
    }
}

export function unfollow(friendEmail: string,) {

    // console.log("unfollow")

    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.delete(`/unfollow/${friendEmail}`);
            dispatch(slice.actions.unFollowSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            // dispatch(slice.actions.UpdateFail());
        }
    }
}




const uploadMultipleFile = async (fileList: (string | File)[]) => {
    // console.log("uploadMultipleFile")
    const postImage: string[] = [];

    // eslint-disable-next-line no-restricted-syntax
    // for (const _file of fileList) {

    for (let i = 0; i < fileList.length; i += 1) {
        const _file = fileList[i];
        // eslint-disable-next-line no-await-in-loop
        const photoURL = await uploadFile(_file);
        if (photoURL)
            postImage.push(photoURL);
    }


    return postImage;
}




const uploadFile = async (_file: File | string) => {
    // console.log("uploadFile")

    try {


        if (_file instanceof Blob) {
            const bucketType = 'photo';
            const fileName = _file.name;
            const fileSize = _file.size.toString();
            const fileType = _file.type;
            const getUploadURLResponse = await axios.post('/get-upload-url', {
                bucketType,
                fileName,
                fileSize,
                fileType,
            });
            // // console.log("getUploadURLResponse")
            // console.log(getUploadURLResponse)
            const signedUrl = getUploadURLResponse.data.signedUrl;
            const photoUrl = getUploadURLResponse.data.photoUrl;
            // console.log(photoUrl)
            if (signedUrl) {
                const uploadFileResponse = await axios2.put(
                    signedUrl,
                    _file,
                    { headers: { 'Content-Type': fileType, }, },
                );


                // // console.log("uploadFileResponse")
                // console.log(uploadFileResponse)
                if (uploadFileResponse.status === 200) {
                    // postImage.push(photoUrl)
                    return photoUrl;
                }
            }
        }

        return null;
    } catch (error) {
        console.log(error);
        return null;
    }




}




export function createPost(input: IUserNewPost) {
    // console.log("createPost")
    return async (dispatch: Dispatch) => {
        // dispatch(slice.actions.startLoading());
        dispatch(slice.actions.startProcessing());

        dispatch(slice.actions.resetError());
        // dispatch(slice.actions.ResetUpdateStatus());

        // // console.log("input")
        // console.log(input)



        try {


            const postImageLength = input.postImage?.length || 0;
            let postImage: string[] = [];
            if (input.postImage && postImageLength)
                postImage = await uploadMultipleFile(input.postImage);



            // // console.log("postImage")
            // console.log(postImage)

            // const postImageString = postImage.toString();
            // console.log(postImageString)

            // input.postImage = postImageString;

            /*
            const _file = input.postImage;
          

            */

            const response = await axios.post('/create-profilepost', {
                // ...input,
                // accessToken
                message: input.message,
                postImage,
            });


            // // console.log("test 1")
            dispatch(slice.actions.createdPostSuccess(response.data));
            // // console.log("test 2")

            // dispatch(slice.actions.stopProcessing())

        } catch (error) {
            // console.log("error");
            console.log(error);
            dispatch(slice.actions.hasError(error));
            // dispatch(slice.actions.UpdateFail());
        }




    }


}

export function deleteUserPost(postId: string) {
    // console.log("deleteUserPost")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.delete(`/delete-profilepost/${postId}`);

            dispatch(slice.actions.deleteUserPostSuccess({ postId }));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function loadUserPosts(profileEmail: string, nextKey?: any) {
    // console.log("loadUserPosts")
    return async (dispatch: Dispatch) => {


        dispatch(slice.actions.resetUserProfilePost());
        dispatch(slice.actions.startLoading());


        try {
            const response = await axios.get(`/user-profilepost/${profileEmail}`,
                {
                    // params: {
                    //     lastKey: nextKey,
                    // }
                });
            dispatch(slice.actions.loadUserPostsSuccess({ profileEmail, ...response.data }));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadMoreUserPosts(profileEmail: string, nextKey: any) {
    // console.log("loadMoreUserPosts")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {


            // // console.log("input.lastKey")
            // console.log(input.lastKey)
            const response = await axios.get(`/user-profilepost/${profileEmail}`, {
                params: {
                    lastKey: nextKey
                }
            });

            dispatch(slice.actions.loadMoreUserPostsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}




export function fetchNewUserPost(profileEmail: string, lastTimestamp: string) {
    // console.log("fetchNewUserPost")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startFetching());
        try {
            // const response = await axios.get(`/latest-profilepost/${profileEmail}`);


            const response = await axios.get(`/user-profilepost/${profileEmail}`, {
                params: {
                    lastTimestamp,
                }
            });


            dispatch(slice.actions.fetchNewUserPostsSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function loadNewUserPost() {
    // console.log("loadNewUserPost")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingNew());
        try {
            dispatch(slice.actions.loadNewUserPostsSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function likePost(postId: string, onDetailpage: boolean = false) {
    // console.log("likePost")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.put(`/favorite-profilepost/${postId}`);
            if (onDetailpage)
                dispatch(slice.actions.likePostSuccess({ postId }));
            else
                dispatch(slice.actions.likePostsSuccess({ postId }));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            // dispatch(slice.actions.UpdateFail());
        }
    }
}

export function unlikePost(postId: string, onDetailpage: boolean = false) {
    // console.log("unlikePost")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.delete(`/unfavorite-profilepost/${postId}`);
            if (onDetailpage)
                dispatch(slice.actions.unlikePostSuccess({ postId }));
            else
                dispatch(slice.actions.unlikePostsSuccess({ postId }));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            // dispatch(slice.actions.UpdateFail());
        }
    }
}




export function replyPost(postId: string, message: string, replyTo?: string) {
    // console.log("replyPost")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.post(`/reply-profilepost`, {
                message,
                postId,
                replyTo,
            });
            dispatch(slice.actions.replyPostSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            // dispatch(slice.actions.UpdateFail());
        }
    }
}

export function deleteReplyPost(replyId: string, replyTo?: string) {
    // console.log("deleteReplyPost")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.delete(`/delete-postreply/${replyId}`);
            dispatch(slice.actions.deleteReplyPostSuccess({ replyId, replyTo }));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            // dispatch(slice.actions.UpdateFail());
        }
    }
}




export function getPost(postId: string) {

    // console.log("getPost")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.resetPost());
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/profilepost/${postId}`, {
            });
            dispatch(slice.actions.getPostSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }

}


// export function setSelectedElement(postElement: HTMLDivElement) {
//     return async (dispatch: Dispatch) => { dispatch(slice.actions.setSelectedElementSuccess(postElement)); }
// }
// export function resetSelectedElement() {
//     return async (dispatch: Dispatch) => { dispatch(slice.actions.resetSelectedElementSuccess()); }
// }



export function getUserInfo(profileEmail: string) {

    // console.log("getUserInfo")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.resetUserProfile());
        dispatch(slice.actions.startLoading());
        try {

            // console.log('User profile dispatch');
            const response = await axios.get(`/user/${profileEmail}`, {
            });
            dispatch(slice.actions.getUserProfileSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }


}





export function setExploreUserScrollTop(scrollTop: number) {
    // console.log("setExploreUserScrollTop")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setExploreUserScrollTop({ scrollTop }));
    }
}
export function setExploreUserSeletedId(selectedId: string) {
    // console.log("setExploreUserSeletedId")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setExploreUserSeletedId({ selectedId }));
    }
}


export function setUserPostsScrollTop(scrollTop: number) {

    // console.log("setUserPostsScrollTop")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setUserPostsScrollTop({ scrollTop }));
    }
}
export function setUserPostsSeletedId(selectedId: string) {

    // console.log("setUserPostsSeletedId")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setUserPostsSeletedId({ selectedId }));
    }
}
export function setExplorePostsScrollTop(scrollTop: number) {

    // console.log("setExplorePostsScrollTop")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setExplorePostsScrollTop({ scrollTop }));
    }
}
export function setExplorePostsSeletedId(selectedId: string) {

    // console.log("setExplorePostsSeletedId")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setExplorePostsSeletedId({ selectedId }));
    }
}
export function setUserFavoritePostsScrollTop(scrollTop: number) {

    // console.log("setUserFavoritePostsScrollTop")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setUserFavoritePostsScrollTop({ scrollTop }));
    }
}
export function setUserFavoritePostsSeletedId(selectedId: string) {

    // console.log("setUserFavoritePostsSeletedId")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setUserFavoritePostsSeletedId({ selectedId }));
    }
}








export function explorePosts(keywords: string) {



    // console.log("explorePosts")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.resetUserProfilePost());
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/explore-profilepost`, {
                params: {
                    keywords
                }
            });
            dispatch(slice.actions.loadExploredPostsSuccess({ keywords, ...response.data }));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadMoreExploredPosts(keywords: string, lastKey: any) {

    // console.log("loadMoreExploredPosts")

    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {
            const response = await axios.get(`/explore-profilepost`, {
                params: {
                    keywords,
                    lastKey
                }
            });

            dispatch(slice.actions.loadMoreExploredPostsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}




export function fetchNewExploredPost(keywords: string, lastTimestamp: string) {
    return async (dispatch: Dispatch) => {




        dispatch(slice.actions.startFetching());
        try {
            // const response = await axios.get(`/latest-profilepost/${profileEmail}`);

            // console.log("fetchNewExploredPost")
            const response = await axios.get(`/explore-profilepost`, {
                params: {
                    keywords,
                    lastTimestamp,
                }
            });


            dispatch(slice.actions.fetchNewExploredPostsSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function loadNewExploredPost() {
    // console.log(`loadNewExploredPost`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingNew());
        try {
            dispatch(slice.actions.loadNewExploredPostsSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}






export function loadUserFavoritePost(profileEmail: string) {
    // console.log(`loadUserFavoritePost`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        dispatch(slice.actions.resetUserFavoritePostsPage());
        try {
            const response = await axios.get(`/get-favorite-profilepost/${profileEmail}`);
            dispatch(slice.actions.loadUserFavoritePostsPageSuccess({ profileEmail, ...response.data }));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function loadMoreUserFavoritePost(profileEmail: string, lastKey: string) {
    // console.log(`loadMoreUserFavoritePost`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {
            const response = await axios.get(`/get-favorite-profilepost/${profileEmail}`, {
                params: {
                    lastKey
                }
            });
            dispatch(slice.actions.loadMoreUserFavoritePostsPageSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}
